module.exports = __webpack_public_path__ + "img/upload.05a1e407.svg";